import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {UnansweredQuestionsDialogComponent} from '../unanswered-questions-dialog/unanswered-questions-dialog.component';

@Component({
  selector: 'app-delete-file-group',
  templateUrl: './delete-file-group.component.html',
  styleUrls: ['./delete-file-group.component.css']
})
export class DeleteFileGroupComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<UnansweredQuestionsDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public dialogData: any) {}

  ngOnInit() {
  }

  close() {
    this.dialogRef.close(false);
  }

  confirm() {
    // @ts-ignore
    console.log('confirming...');
    this.dialogRef.close(true);
  }
}
